import { IState } from "store/index";

export const isLoadingSelector = (state: IState) => state.app.users.isLoading;
export const userListSelector = (state: IState) => state.app.users.list.items;
export const userDetailSelector = (state: IState) =>
  state.app.users.detail.user;
export const userListDimSelector = (state: IState) =>
  state.app.users.list.dimensions;
